
import React from "react";
import { Button } from "@/components/ui/button";
import { ListCheck, FileText, Check } from "lucide-react";

interface PrimaryButtonProps {
  isInLeads: boolean;
  onJoinWaitlist: () => void;
}

export function PrimaryButton({ isInLeads, onJoinWaitlist }: PrimaryButtonProps) {
  return (
    <Button 
      className={`w-full ${isInLeads 
        ? 'bg-grandpal-green-dark' 
        : 'bg-grandpal-green-dark hover:bg-grandpal-green-darkHover'} text-lg py-6`}
      size="lg"
      onClick={onJoinWaitlist}
      disabled={isInLeads}
    >
      {isInLeads ? (
        <>
          <Check className="mr-2 h-5 w-5" />
          Added to List
        </>
      ) : (
        <>
          <ListCheck className="mr-2 h-5 w-5" />
          Join Waitlist
        </>
      )}
    </Button>
  );
}

interface SecondaryButtonProps {
  onClick: () => void;
}

export function GuideButton({ onClick }: SecondaryButtonProps) {
  return (
    <Button 
      variant="outline" 
      className="w-full border-gray-300 text-gray-700 hover:bg-gray-50"
      onClick={onClick}
    >
      <FileText className="mr-2 h-4 w-4" />
      Download Guide
    </Button>
  );
}
